import React from 'react';
import SystemClient from '../../system/SystemClient';
import MessageCourier from '../../lib/MessageCourier';
import { Usuario } from '../../system/Usuario/Usuario';
import PlanillaPartidoOfflineView from './PlanillaPartidoOfflineView';
import ViewWrapperWithCommandBar from '../Common/Layout/ViewWrapperWithCommandBar';
import {
  buttonStylesForProjects,
  defaultCommandBarButtonStyles,
  titleCommandBarButtonStyles,
} from '../../styles/button-styles';
import { ICommandBarItemProps } from '@fluentui/react/lib/CommandBar';
import { DefaultPalette } from 'office-ui-fabric-react';
import PlanillaPartidoOfflineForm from './PlanillaPartidoOfflineForm';
import { useNavigate } from 'react-router-dom';
import { routes } from '../../common/routes';
import { PlanillaPartido } from '../../system/PlanillaPartido/PlanillaPartido';
import ErroresPopUp from '../PlanillaPartido/Programado/Confeccion/ErroresPopUp';
import { PlanillaPartidoOficial } from '../../system/PlanillaPartidoOficial/PlanillaPartidoOficial';
import { PlanillaPartidoJugador } from '../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import {
  MIN_HANDBALL_PLAYERS_PER_TEAM,
  MAX_HANDBALL_PLAYERS_PER_TEAM,
} from './ConfeccionPlanillaPartidoTeamOffline';

interface IPlanillaPartidoOfflineViewControllerProps {
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  setPlanillaPartido: (planillaPartido: PlanillaPartido) => void;
  setIsPartidoOnline: (b: boolean) => void;
}

const PlanillaPartidoOfflineViewController = ({
  system,
  courier,
  changeBlockUI,
  setPlanillaPartido,
  setIsPartidoOnline,
}: IPlanillaPartidoOfflineViewControllerProps) => {
  const [formIsValid, setFormIsValid] = React.useState(false);

  const [form, setForm] = React.useState<PlanillaPartidoOfflineForm>(PlanillaPartidoOfflineForm.initialize());

  const navigate = useNavigate();
  const onBlurCustomInput = () => {
    if (form) {
      setFormIsValid(form.isValid());
    }
  };

  const [showErroresPopUp, setShowErroresPopUp] = React.useState<boolean>(false);
  const [errores, setErrores] = React.useState<string[]>([]);

  const validarInformacionBasica = () => {
    let ret: string[] = [];
    if (form?.getCampoDeJuegoInput().getValue() === '') {
      ret.push('No posee campo de juego');
    }
    if (form?.getFechaHoraInicioInput().getValue() === null) {
      ret.push('No posee Fecha de inicio');
      ret.push('No posee Hora de inicio');
      ret.push('No posee Minuto de inicio');
    } else {
      if (isNaN(form?.getFechaHoraInicioInput().getValue())) {
        ret.push('No posee Fecha de inicio');
        ret.push('No posee Hora de inicio');
        ret.push('No posee Minuto de inicio');
      }
      if (form?.getHorario().split(':')[0] === '') {
        ret.push('No posee Hora de inicio');
      }
      if (form?.getHorario().split(':')[1] === '') {
        ret.push('No posee Minuto de inicio');
      }
    }
    if (
      form?.getOficialDeMesaLocalForm().getApellidoInput().getValue() === '' ||
      form?.getOficialDeMesaLocalForm().getNombreInput().getValue() === '' ||
      form?.getOficialDeMesaLocalForm().getNroDocInput().getValue() === ''
    ) {
      ret.push('Datos incompletos del oficial de mesa local');
    }
    if (
      form?.getOficialDeMesaVisitanteForm().getApellidoInput().getValue() === '' ||
      form?.getOficialDeMesaVisitanteForm().getNombreInput().getValue() === '' ||
      form?.getOficialDeMesaVisitanteForm().getNroDocInput().getValue() === ''
    ) {
      ret.push('Datos incompletos del oficial de mesa visitante');
    }
    if (form?.getPartidoForm().getClubLocalInput().getValue() === '') {
      ret.push('No posee club local');
    }
    if (form?.getPartidoForm().getClubVisitanteInput().getValue() === '') {
      ret.push('No posee club visitante');
    }
    if (form?.getPartidoForm().getTorneoForm().getNombreInput().getValue() === '') {
      ret.push('No posee nombre de torneo');
    }
    if (form?.getPartidoForm().getTorneoForm().getRamaInput().getValue() === '') {
      ret.push('No posee rama de torneo');
    }
    if (form?.getPartidoForm().getTorneoForm().getCatInput().getValue() === '') {
      ret.push('No posee categoria de torneo');
    }
    if (form?.getPartidoForm().getTorneoForm().getDivInput().getValue() === '') {
      ret.push('No posee division de torneo');
    }
    if (
      form?.getArbitro1Form().getApellidoInput().getValue() === '' ||
      form?.getArbitro1Form().getNombreInput().getValue() === '' ||
      form?.getArbitro1Form().getTipoDocInput().getValue() === '' ||
      form?.getArbitro1Form().getNroDocInput().getValue() === ''
    ) {
      ret.push('Datos incompletos del primer arbitro');
    }
    if (
      form?.getPartidoForm().getTorneoForm().getCantPerInput().getValue() === null ||
      form?.getPartidoForm().getTorneoForm().getDurPerInput().getValue() === null
    ) {
      ret.push('Datos incolmpletos de la configuracion del tiempo regular');
    }
    if (
      !form?.getPartidoForm().getTorneoForm().getEmpInput().getValue() &&
      (form?.getPartidoForm().getTorneoForm().getCantTeInput().getValue() === null ||
        form?.getPartidoForm().getTorneoForm().getDurTeInput().getValue() === null)
    ) {
      ret.push('Datos incolmpletos de la configuracion del tiempo extra');
    }

    return ret;
  };

  const validarEquipos = () => {
    let ret: string[] = [];

    if (form) {
      const jugadores = form?.getPlanillaPartidoJugadoresInput().getValue() as PlanillaPartidoJugador[];

      const equipoLocalId = form.getEquipoLocalIdInput();
      const equipoVisitanteId = form.getEquipoVisitanteIdInput();

      // tomo los jugadores que tengan dorsal asignado
      let jugadoresLocal: PlanillaPartidoJugador[] = jugadores.filter(
        (ppj) => !!ppj.getDorsal() && +ppj.getEqid() === +equipoLocalId.getValue()
      );
      let jugadoresVisitantes: PlanillaPartidoJugador[] = jugadores.filter(
        (ppj) => !!ppj.getDorsal() && !!ppj.getDorsal() && +ppj.getEqid() === +equipoVisitanteId.getValue()
      );

      const cantJugadoresLocal = jugadoresLocal.length;
      const cantJugadoresVisitante = jugadoresVisitantes.length;

      const min = MIN_HANDBALL_PLAYERS_PER_TEAM;
      const max = MAX_HANDBALL_PLAYERS_PER_TEAM;

      if (cantJugadoresLocal < min || cantJugadoresLocal > max) {
        ret.push(`La cantidad de jugadores del equipo local debe estar entre ${min} y ${max}`);
      }
      if (cantJugadoresVisitante < min || cantJugadoresVisitante > max) {
        ret.push(`La cantidad de jugadores del equipo visitante debe estar entre ${min} y ${max}`);
      }
      const oficiales = form?.getOficialesInput().getValue() as PlanillaPartidoOficial[];

      if (!oficiales.some((ppo) => +ppo.getEqid() === +equipoLocalId.getValue())) {
        ret.push('El equipo local no tiene asignado un oficial A');
      }

      if (!oficiales.some((ppo) => +ppo.getEqid() === +equipoVisitanteId.getValue())) {
        ret.push('El equipo visitante no tiene asignado un oficial A');
      }
    }

    return ret;
  };

  const validarInicioPartido = () => {
    let ret: string[] = [];
    ret = ret.concat(validarInformacionBasica());
    ret = ret.concat(validarEquipos());
    return ret;
  };

  const onClickIniciarPartido = () => {
    const errors = validarInicioPartido();
    if (errors.length === 0 && form) {
      const pp = form.toPlanillaPartido();
      setPlanillaPartido(pp);
      setIsPartidoOnline(false);
      navigate(routes.planilla_partido.route + '/new');
    } else {
      setErrores(errors);
      setShowErroresPopUp(true);
    }
  };

  const itemsMenu = React.useMemo((): ICommandBarItemProps[] => {
    let ret: ICommandBarItemProps[] = [];
    ret.push(
      {
        key: 'title',
        text: 'Planilla partido offline',
        iconProps: {
          iconName: 'SwitcherStartEnd',
          color: DefaultPalette.themeLighterAlt,
          className: 'text-title-btn',
        },
        buttonStyles: titleCommandBarButtonStyles,
        className: 'text-title-btn',
        // onClick: () => navigate(routes.planilla_partido_programado.route),
      },
      // {
      //   key: 'save',
      //   text: 'Guardar',
      //   iconProps: {
      //     iconName: 'Save',
      //     color: DefaultPalette.themeLighterAlt,
      //     className: 'text-title-btn',
      //   },
      //   buttonStyles: buttonStylesForProjects,
      //   className: 'text-title-btn',
      //   onClick: () => alert('to do'),
      //   disabled: false,
      // },
      {
        key: 'planilla',
        text: 'Iniciar partido',
        iconProps: {
          iconName: 'AccountActivity',
          color: DefaultPalette.themeLighterAlt,
          className: 'text-title-btn',
        },
        buttonStyles: titleCommandBarButtonStyles,
        className: 'text-title-btn',
        onClick: () => onClickIniciarPartido(),
        disabled: false,
      },
      {
        key: 'back',
        text: 'Volver',
        iconProps: {
          iconName: 'Back',
          color: DefaultPalette.themeLighterAlt,
          className: 'text-title-btn',
        },
        buttonStyles: titleCommandBarButtonStyles,
        className: 'text-title-btn',
        onClick: () => alert('to do'),
      }
    );
    return ret;
  }, []);

  return (
    <ViewWrapperWithCommandBar
      withBorderBottom
      title={''}
      items={itemsMenu}
      overflowButtonStyles={defaultCommandBarButtonStyles}
      variant="highlight"
      titleBody="Nuevo CostoValorHist"
    >
      <>
        {form && (
          <>
            {showErroresPopUp && errores.length > 0 && (
              <ErroresPopUp
                onAccept={() => setShowErroresPopUp(false)}
                showDialog={showErroresPopUp}
                errores={errores}
              />
            )}
            <PlanillaPartidoOfflineView
              onBlurCustomInput={onBlurCustomInput}
              form={form}
              changeBlockUI={changeBlockUI}
              system={system}
            />
          </>
        )}
      </>
    </ViewWrapperWithCommandBar>
  );
};

export default PlanillaPartidoOfflineViewController;
